import { render } from "./EditeCustomer.vue?vue&type=template&id=24d65d03&scoped=true"
import script from "./EditeCustomer.vue?vue&type=script&lang=js"
export * from "./EditeCustomer.vue?vue&type=script&lang=js"

import "./EditeCustomer.vue?vue&type=style&index=0&id=24d65d03&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24d65d03"]])

export default __exports__